<template>
  <div class="row m-0 p-0">

        <b-sidebar id="main-sidebar" backdrop backdrop-variant="dark"
                   bg-variant="dark" text-variant="info">
            <template #title>
                <b-navbar-brand>
                    <i class="fa fa-2x fa-paw" />
                </b-navbar-brand>
            </template>
            <template #default>
                <nav class="mb-3">
                    <sidebar :links="links">
                    </sidebar>
                </nav>
            </template>
        </b-sidebar>


        <div class="col-12 col-sm p-0 d-flex flex-column"  style="min-height: 100vh">
            <top-navbar />
            <sub-top-navbar />
            <dashboard-content />
            <content-footer />
        </div>

        <transition name="popup" mode="out-in">
            <div class="mobile-menu col-12 p-0 h-100" v-if="getIsMobileMenuVisible">
                <mobile-menu :links="mobileLinks">
                </mobile-menu>
            </div>
        </transition>


  </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import TopNavbar from "./TopNavbar.vue";
    import ContentFooter from "./ContentFooter.vue";
    import DashboardContent from "./Content.vue";
    import MobileMenu from "./MobileMenu";
    import SubTopNavbar from "./SubTopNavbar";
    import SidebarLink from "../../components/Sidebar/SidebarLink";
    import Sidebar from "../../components/Sidebar/Sidebar";

    export default {
        components: {
            Sidebar,
            MobileMenu,
            SubTopNavbar,
            TopNavbar,
            ContentFooter,
            DashboardContent,
        },
        props: {
            links: { type: Array },
            mobileLinks: { type: Array }
        },
        data() {
            return {
                sidebarTitle: null
            }
        },
        computed: {
          ...mapGetters(['getIsMobileMenuVisible', 'getRoute'])
        },
        methods: {
        },
        mounted() {
          this.sidebarTitle = process.env.VUE_APP_TITLE;
        }
    };
</script>

<style lang="scss">
    .popup-enter-active, .popup-leave-active {
      transition: opacity .3s;
    }
    .popup-enter, .popup-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
</style>
